import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "../lib/brand";

export const Hero = ({ onBook }) => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative w-full min-h-[100svh] overflow-hidden"
    >
      {/* Background video — stabilized, centered */}
      <video
        data-testid="hero-video"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster={BRAND.heroFallbackImage}
        className="absolute inset-0 w-full h-full object-cover"
        style={{
          objectPosition: "center center",
          transform: "scale(1.08)",
          willChange: "transform",
        }}
      >
        <source src={BRAND.heroVideoUrl} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 hero-vignette" />

      {/* Content */}
      <div className="relative z-10 h-full min-h-[100svh] flex flex-col items-center justify-center px-6 text-center">
        <h1
          data-testid="hero-heading"
          className="font-serif-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[1.02] font-light max-w-5xl"
        >
          Where Calm <em className="italic font-normal text-[#EAC98A]">Becomes</em>
          <br className="hidden sm:block" /> Your Power
        </h1>

        <p
          data-testid="hero-subtitle"
          className="mt-8 max-w-xl text-base md:text-lg text-white/85 leading-relaxed font-light"
        >
          A modern sanctuary of breath, movement and transformation — crafted for
          the rhythm of your life.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Link
            to="/products"
            data-testid="hero-shop-btn"
            className="group bg-[#D4A24C] hover:bg-[#C29344] text-[#153326] rounded-full px-8 py-4 text-sm font-semibold tracking-wide shadow-[0_16px_40px_rgba(212,162,76,0.35)] hover:shadow-[0_22px_50px_rgba(212,162,76,0.55)] transition-all duration-400 hover:-translate-y-0.5 inline-flex items-center justify-center"
          >
            Explore Product Shop
            <span className="inline-block ml-2 transition-transform group-hover:translate-x-1">→</span>
          </Link>
          <a
            href="#classes"
            data-testid="hero-explore-btn"
            className="rounded-full border border-white/40 text-white/95 hover:bg-white hover:text-[#1F4A38] px-8 py-4 text-sm font-medium tracking-wide transition-all duration-400 backdrop-blur-sm"
          >
            Explore Our Classes
          </a>
        </div>
      </div>

      {/* Scroll cue */}
      <a
        href="#classes"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/80 flex flex-col items-center gap-2 animate-bounce"
      >
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <ChevronDown size={18} />
      </a>
    </section>
  );
};

export default Hero;
